import React, {useContext, useEffect, useState, Fragment} from "react";
import TableSection from "components/sales/tableSection/tableSection";
import {BaseUrl} from "../../../../../contexts/baseUrl/baseUrl";
import Layout from "../../../../../components/sales/layout/layout";
import {toast} from "react-toastify";
import localization from "../../../../../assets/localization/localization";
import Images from "../../../../../assets/images/imageData";
import {Link} from "react-router-dom";
import ModalPop from "../../../../../components/sales/modal/modal";
import ConstantInput from "../../../../../components/sales/Input/constantInput/constantInput";
import {Button} from "react-bootstrap";
import DropDownInput from "../../../../../components/sales/Input/dropDownInput/dropDownInput";
import {payoutConfigurationVerifyRequest} from "../../../../../services/redux/CarLoan/action";

const BankSheetList = ({
                           match,
                           payoutConfigurationListRequest,
                           payoutConfigurationListResponse = [],
                           payoutConfigurationVerifyResponse = [],
                           payoutConfigurationVerifyRequest
                       }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [roleId, setRoleId] = useState();
    const [userId, setUserId] = useState();
    const [ucdBankSheetId, setBankSheetId] = useState();
    const [remarks, setRemarks] = useState('');
    const [status, setStatus] = useState('');

    useEffect(() => {
        (async () => {
            setRoleId(window.localStorage.getItem("fusion-role"));
            setUserId(JSON.parse(window.localStorage.loginDetails)?.id);
            setIsLoading(true);
            await payoutConfigurationListRequest(1);
            setIsLoading(false);
        })();
    }, []);

    const headers = [
        "Start Date",
        "End Date",
        "File",
        'Remark',
        "Status",
        (parseInt(roleId) === 49 || parseInt(roleId) === 13) ? "Action" : "",
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await payoutConfigurationListRequest(val.selected + 1);
        setIsLoading(false);
    };

    console.log("payoutConfigurationListResponse", payoutConfigurationListResponse)
    useEffect(() => {
        if (
            payoutConfigurationListResponse &&
            payoutConfigurationListResponse?.results &&
            payoutConfigurationListResponse?.results.length > 0
        ) {
            const tableData = [
                'id',
                "effective_start_date",
                "effective_end_date",
                "file_url",
                'remark',
                "status",
            ];
            const data = payoutConfigurationListResponse?.results.map((element) =>
                Object.assign(
                    ...tableData.map((key) =>
                        key === "file_url"
                            ? {[key]: <a href={element[key]} target="_blank">File</a>}
                            : {[key]: element[key]}
                    ),
                    (parseInt(roleId) === 49 || parseInt(roleId) === 13) ? {
                      Action: [
                          {name: "Sheet Status", link: `#`}
                      ],
                    } : ""
                )
            );
            if (data) {
                data.map((val, i) => {
                    if(val?.remark || val?.status === 'ACCEPTED'){
                        delete data[i]['Action'];
                    }
                })
                data && setListData(data);
            }
            setPageCount(
                Math.ceil(
                    payoutConfigurationListResponse?.total / payoutConfigurationListResponse?.per_page
                )
            );
        }
    }, [payoutConfigurationListResponse]);


    useEffect(() => {
        console.log(payoutConfigurationVerifyResponse)
        if (parseInt(payoutConfigurationVerifyResponse?.status) === 200) {
            toast.success(payoutConfigurationVerifyResponse?.message);
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } else if (payoutConfigurationVerifyResponse?.status !== 200) {
            toast.error(payoutConfigurationVerifyResponse?.message);
        }
    }, [payoutConfigurationVerifyResponse]);

    const handleContinue =  async () => {
        if(status === 'REJECTED' && !remarks){
            toast.error("Remark is required!");
            return false
        }

        setIsLoading(true);
        await payoutConfigurationVerifyRequest({status: status, remark: remarks, configuration_log_id: ucdBankSheetId});
        setIsLoading(false)
    };

    const handleModalHidden = () => setBankSheetId('')
    return (
        <>
            <Layout
                title={"Payout Listing"}
                isLoading={isLoading}
                isGoback={true}
                // Buttons={headerBtns}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={payoutConfigurationListResponse?.results}
                    srNo={payoutConfigurationListResponse?.from}
                    setBankSheetId={setBankSheetId}
                />

                {ucdBankSheetId &&
                <>
                    <ModalPop
                        title="Change Status"
                        show={true}
                        handleModalHide={handleModalHidden}
                    >
                        <Fragment>
                            <div className="modal-body">
                                <div className="text-center">
                                    {/*<h5>{localization.approve}</h5>*/}
                                    {/*<div className="form-group">*/}
                                        <div className="col-md-12">
                                            <DropDownInput
                                                label={"Status"}
                                                data={[{id: 'ACCEPTED', name: 'Accepted'},
                                                    {id:'REJECTED', name: 'Rejected'}]}
                                                getIdValue={(val) => {setStatus(val.id)}}
                                                value={""}
                                                isStarRequired={true}
                                            />
                                        </div>
                                        {status === 'REJECTED' &&
                                            <div className="col-md-12">
                                                <ConstantInput
                                                    label={localization.addRemark}
                                                    required
                                                    isStarRequired={true}
                                                    type="text"
                                                    handleChange={(val) => {
                                                        setRemarks(val);
                                                    }}
                                                />
                                            </div>
                                        }

                                    {/*</div>*/}
                                    <Button
                                        className="btn btn-primary justify-content-center"
                                        onClick={handleContinue}
                                    >
                                        {localization.continue}{' '}
                                        <img src="../images/arrow-right.png" alt=""/>
                                    </Button>
                                </div>
                            </div>

                        </Fragment>
                    </ModalPop>
                </>
                }
            </Layout>
        </>
    );
};

export default BankSheetList;
